/* tslint:disable no-any */
import React from "react";

import { findDOMNode } from "react-dom";

import Input, { InputAdornment, InputProps } from "material-ui/Input";
import LensIcon from "material-ui-icons/Lens";

import { withStyles } from "material-ui/styles";

import logger from "../../util/logger";

interface IExtendedInputProps extends InputProps {
    delay?: number;
    onChangeUsesEvent?: boolean;
    label?: string;
    adornment?: string;
    required?: boolean;
    isAutosuggest?: boolean;
    isAutoComplete?: boolean;
}

interface IInputState {
    stateValue: string;
}

class TextInput extends React.PureComponent<IExtendedInputProps, IInputState> {
    public static defaultProps: IExtendedInputProps = {
        label: "",
        delay: 200,
        adornment: "",
        required: false,
        isAutosuggest: false,
        isAutoComplete: false,
    };

    timer: number | null;
    input: HTMLInputElement | HTMLTextAreaElement;

    constructor(props: IExtendedInputProps) {
        super(props);
        let v = props.value ? props.value : "";
        this.state = {
            stateValue: `${v}`,
        };

        this.timer = null;
    }

    _change = (value: string) => {
        const { input } = this;
        const DOM = findDOMNode(input) as any;

        DOM && DOM.MaterialTextfield && DOM.MaterialTextfield.change(value);
    };

    _update = () => {
        const { input } = this;
        const DOM = findDOMNode(input) as any;
        DOM && DOM.MaterialTextfield && DOM.MaterialTextfield.updateClasses_();
    };

    _checkFocus = () => {
        const { input } = this;
        const DOM = findDOMNode(input) as any;
        //logger.info("focusing", DOM);
        DOM && DOM.focus();

        this._update();
    };

    _getInput = () => {
        if (this.input) {
            const a: any = this.input as any;
            return a;
        }
        return null;
    };

    focus() {
        //logger.info("focus");
        const input = this._getInput();
        input && input.focus();

        const dom: any = findDOMNode(this.input) as any;
        //dom && dom.MaterialTextfield.checkFocus();
    }

    handleBlur = (_event: any) => {
        //logger.info("Blur");
        if (this.props.onBlur) {
            this.props.onBlur(_event);
        }
        this._update();
    };

    componentWillReceiveProps(nextProps: IExtendedInputProps) {
        const { stateValue } = this.state;
        const { value } = nextProps;
        const anyValue = value as any;

        let v = value ? value : ""; //anyValue && anyValue.target ? anyValue.target.value : anyValue ? anyValue : "";

        if (v !== stateValue) {
            this.setState({ stateValue: `${v}` }, () => {
                const input = this._getInput();
                if (input) {
                    this._change("" + v);
                } else {
                    //console.warn("No input"), this.input;
                }
            });
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    handleOnChange = (event: any) => {
        event.preventDefault();

        const newValue = event.target.value;

        this.setState({ stateValue: newValue }, () => {
            this._change(newValue);
        });

        if (this.props.onChangeUsesEvent) {
            let fakeEvent = {
                target: {
                    value: newValue,
                },
            };
            this.setTimerBeforeCallback(fakeEvent);
        } else {
            this.setTimerBeforeCallback(newValue);
        }
    };

    setTimerBeforeCallback = (value: string | any) => {
        const { onChange, delay } = this.props;

        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        let fakeEvent = {
            target: {
                value: value,
            },
        };

        this.timer = setTimeout(
            () =>
                onChange &&
                onChange(this.props.isAutosuggest ? (fakeEvent as any) : value),
            delay
        );
    };

    render() {
        const {
            onChange,
            delay,
            value,
            adornment,
            onBlur,
            onChangeUsesEvent,
            isAutosuggest,
            isAutoComplete,
            ...args
        } = this.props;

        const type = this.props.type;
        const isTextArea: boolean = type === "textarea" ? true : false;
        const errorClass = this.props.error ? " error" : "";

        const { stateValue } = this.state;
        //const useDefault = isAutoComplete ? { value: stateValue } : { defaultValue: stateValue };
        const useDefault = { value: stateValue };

        return (
            <div>
                {/* <span style={{color: "red"}}>{this.props.error}</span> */}
                <label>
                    {isTextArea && this.props.label}
                    {isTextArea && this.props.required && (
                        <LensIcon className={"hypo-lens-icon" + errorClass} />
                    )}
                    <Input
                        {...args}
                        inputRef={(c) => (this.input = c!)}
                        {...useDefault}
                        onInput={this.handleOnChange}
                        onBlur={this.handleBlur}
                        error={!!this.props.error}
                        multiline={isTextArea}
                        classes={{
                            error: "hypo-error",
                            focused: "hypoblue",
                            disabled: "hypo-disabled",
                            root: "hypoblue",
                            underline: isTextArea
                                ? "hypoblue-topline"
                                : "hypoblue-underline",
                            input: "hypoblue",
                        }}
                        endAdornment={
                            <InputAdornment
                                classes={{ root: "adornment-bold" }}
                                position="end"
                            >
                                {adornment}
                            </InputAdornment>
                        }
                    />
                    {!isTextArea && this.props.label}
                    {!isTextArea && this.props.required && (
                        <LensIcon className={"hypo-lens-icon" + errorClass} />
                    )}
                    <br />
                    <span style={{ color: "#C85200" }} tabIndex={0}>
                        {this.props.error}
                    </span>
                </label>
            </div>
        );
    }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/TextInput.tsx